import { ValidationModel, ValidationType } from "@/services/validation/types";

export const settingsValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    description: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    notificationIntervalHours: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel
};
